export enum GenericModal {
  CONNECT_TO_PRINTER_WARNING = "CONNECT_TO_PRINTER_WARNING",
  PREP_REQUIRED = "PREP_REQUIRED",
}
